import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    container: {
        overflow: 'hidden',
    },
    // SwipeRow 隐藏层容器（操作按钮所在层）
    hiddenContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'stretch',
    },
    // 左侧隐藏操作按钮区域（右滑显示）
    leftHiddenActions: {
        flexDirection: 'row',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
    },
    // 右侧隐藏操作按钮区域（左滑显示）
    rightHiddenActions: {
        flexDirection: 'row',
        alignItems: 'stretch',
        justifyContent: 'flex-end',
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
    },
    // ---- 以下保留原有样式供 action 按钮使用 ----
    contentWrapper: {
        flexDirection: 'row',
        alignItems: 'stretch',
    },
    content: {
        zIndex: 1,
    },
    actionsContainer: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        flexDirection: 'row',
        alignItems: 'stretch',
    },
    rightActionsContainer: {
        right: 0,
    },
    leftActionsContainer: {
        left: 0,
    },
    actionButton: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 12,
    },
    actionIcon: {
        marginBottom: 4,
    },
    actionText: {
        fontSize: 12,
        fontWeight: '500',
        textAlign: 'center',
    },
});

export const defaultColors = {
    delete: '#FF3B30',
    favorite: '#FF9500',
    similar: '#FF6B00',
    default: '#C7C7CC',
};
